export default "__VITE_ASSET__670f8abe__"